const zh = {
  // Navbar
  "nav.about": "关于我们",
  "nav.services": "核心服务",
  "nav.cases": "案例库",
  "nav.roadmap": "进化蓝图",
  "nav.cta": "👉 唤醒怪兽",
  "nav.langToggle": "EN",

  // Hero
  "hero.tagline": "脑洞算力 · 一口吃定 · 影视级大片 · 7天交付",
  "hero.scrollLabel": "向下滚动",

  // About
  "about.sectionTag": "ABOUT_US.exe",
  "about.sloganMain": "七日交付",
  "about.sloganPre": "像素怪兽兑现每一帧",
  "about.sloganHighlight": "电影级",
  "about.sloganPost": "想象",
  "about.titleLine1": "一群驯服 AI 的",
  "about.titleLine2": "视觉野生怪兽",
  "about.card1Label": "// 01_IDENTITY",
  "about.card1Text1": "欢迎来到",
  "about.card1Brand": "像素怪兽 (Pixel Monster)",
  "about.card1Text2": "的巢穴。我们不是那种开个会要半天、定个灯光要两天、剧组盒饭还要吃掉你一半预算的传统影视公司。我们是一家纯正的",
  "about.card1Highlight": "\"AI 视频造梦厂\"",
  "about.card1Text3": "。",
  "about.card2Label": "// 02_POWER",
  "about.card2Text1": "在这里,没有拖沓的转场,只有",
  "about.card2Highlight1": "炸裂的算力",
  "about.card2Text2": "。我们的主食是",
  "about.card2Highlight2": "行业最前沿的 AI 大模型",
  "about.card2Text3": "(并且我们对如何写出能让 AI 乖乖听话的\"咒语\"了如指掌)。",
  "about.card3Label": "// 03_PROMISE",
  "about.card3Text1": "我们的承诺简单粗暴:",
  "about.card3Highlight1": "高质,高效,不磨叽",
  "about.card3Text2": "。脚本确定后,倒计时",
  "about.card3Highlight2": "七天",
  "about.card3Text3": ",签收你的爆款大片。",
  "about.card3Cta": "查看我们的案例",
  "about.workspaceLabel": "// WORKSPACE",
  "about.workspaceDesc": "AI 算力驱动的创作空间",
  "about.techLabel": "// TECHNOLOGY",
  "about.techDesc": "行业顶尖 AI 模型 × 视觉魔法",

  // Services
  "services.sectionTag": "CORE_SERVICES.sys",
  "services.title": "怪兽の四大绝招",
  "services.subtitle": "// 用 AI 算力重新定义视频制作",
  "services.featuresLabel": "// 怪兽猎物_",
  "services.cta": "了解更多",
  "services.s1.number": "01_",
  "services.s1.title": "📺 产品广告 TVC",
  "services.s1.subtitle": "让你的产品在屏幕上\"开挂\"",
  "services.s1.description": "传统实拍拍不出水滴的完美弧线?搭不出未来的赛博朋克厨房?交给我们。",
  "services.s1.f1": "无论是走心温情的智能家电故事片、质感拉满的高端美容仪大片,还是让人直呼过瘾的快消饮品创意广告",
  "services.s1.f2": "精准把控从\"温馨合家欢\"到\"极简高级感\"的各种美术风格",
  "services.s1.f3": "不用等老天爷给好天气,怪兽的服务器里天天都是黄金光线",
  "services.s2.number": "02_",
  "services.s2.title": "🎵 音乐 MV & 虚拟偶像",
  "services.s2.subtitle": "造星,我们是量产的",
  "services.s2.description": "想为你的品牌定制一首超强洗脑神曲?或者干脆推出一个永不塌房的男团女团?",
  "services.s2.f1": "提供从 AI 音乐生成(词曲全包,多语种演唱无压力)到 MV 画面生成的一条龙服务",
  "services.s2.f2": "精通如何为虚拟偶像组合、数字人偶像打造专属的视觉、声音以及人设",
  "services.s2.f3": "打造永不疲倦的超级偶像团体",
  "services.s3.number": "03_",
  "services.s3.title": "🤖 数字人 IP 视频",
  "services.s3.subtitle": "永不疲倦的超级代言人",
  "services.s3.description": "真人 KOL 会累、会涨价,但我们的数字人不会。我们提供AI数字人整套解决方案，让它成为您的专属赛博明星",
  "services.s3.f1": "为企业孵化专属数字人 IP,从短视频矩阵内容产出、商业化带货视频,到品牌故事宣发",
  "services.s3.f2": "帮你打造拥有完美人设、零帧起手的专属超级代言人",
  "services.s3.f3": "24/7 全天候内容生产,永不停歇",
  "services.s4.number": "04_",
  "services.s4.title": "🌌 展会大屏 & 线下视觉",
  "services.s4.subtitle": "震撼视网膜的终极武器",
  "services.s4.description": "要在行业展会、AI 艺术节或是科技大会上让潜在客户被你的产品抓住眼球?",
  "services.s4.f1": "巨幅尺寸、超高分辨率的视觉冲击",
  "services.s4.f2": "无论是裸眼 3D 效果的先锋视觉,还是宏大的未来城市沙盘",
  "services.s4.f3": "怪兽吐出的每一帧像素都在帮你抢夺线下流量",

  // Cases
  "cases.sectionTag": "CASE_LIBRARY.db",
  "cases.title": "像素怪兽案例库",
  "cases.filterAll": "全部",
  "cases.filterTvc": "TVC",
  "cases.filterMv": "MV",
  "cases.filterDigital": "数字人",
  "cases.filterExhibition": "展会",
  "cases.filterDrama": "AI短剧",
  "cases.noResults": "// NO_RESULTS_FOUND",
  "cases.noResultsDesc": "该分类暂无案例",
  "cases.featured": "FEATURED",
  "cases.case1.title": "高端床垫新品大片",
  "cases.case1.desc": "极简高级感 × 未来科技美学",
  "cases.case1.tag1": "产品广告",
  "cases.case1.tag2": "高端美妆",
  "cases.case1.tag3": "60秒",
  "cases.case2.title": "虚拟二次元偶像出道 MV",
  "cases.case2.desc": "赛博朋克风格 × 动感电音",
  "cases.case2.tag1": "音乐视频",
  "cases.case2.tag2": "虚拟偶像",
  "cases.case2.tag3": "90秒",
  "cases.case3.title": "AWE家电年度科技展会线下开场大片",
  "cases.case3.desc": "裸眼3D × 震撼视觉",
  "cases.case3.tag1": "展会大屏",
  "cases.case3.tag2": "科技感",
  "cases.case3.tag3": "120秒",
  "cases.case4.title": "智能家电温情故事片",
  "cases.case4.desc": "温馨合家欢 × 生活美学",
  "cases.case4.tag1": "品牌故事",
  "cases.case4.tag2": "家电",
  "cases.case4.tag3": "75秒",
  "cases.case5.title": "数字人品牌代言",
  "cases.case5.desc": "专属IP × 全场景应用",
  "cases.case5.tag1": "数字人IP",
  "cases.case5.tag2": "品牌代言",
  "cases.case5.tag3": "系列视频",
  "cases.case6.title": "AI短剧/动漫创作",
  "cases.case6.desc": "视觉爆炸 × 青春力MAX",
  "cases.case6.tag1": "AI短剧",
  "cases.case6.tag2": "创意动画",
  "cases.case6.tag3": "60秒",
  "cases.case7.title": "动漫剧集/AI短剧",
  "cases.case7.desc": "二次元宇宙 × AI 剧情引擎",
  "cases.case7.tag1": "动漫剧集",
  "cases.case7.tag2": "AI短剧",
  "cases.case7.tag3": "系列内容",

  // Roadmap
  "roadmap.sectionTag": "EVOLUTION_MAP.json",
  "roadmap.title": "怪兽进化论",
  "roadmap.subtitle": "// 从效率怪兽到 AI 视觉基础设施的进化之路",
  "roadmap.p1.number": "Phase 1",
  "roadmap.p1.title": "⚡️ 效率巨兽",
  "roadmap.p1.target": "成为行业\"交付天花板\"。死磕 60-90 秒视频的 7 天交付标准,用极致的性价比和高质量碾压传统外包。",
  "roadmap.p1.a1": "建立涵盖短视频、TVC、MV 的庞大 AI 视频案例库",
  "roadmap.p1.a2": "打响\"找像素怪兽,省钱又震撼\"的厂牌名号",
  "roadmap.p1.a3": "优化 AI 工作流,实现标准化快速交付",
  "roadmap.p2.number": "Phase 2",
  "roadmap.p2.title": "🧠 IP 孵化巢穴",
  "roadmap.p2.target": "从\"帮别人做代工\"升级为\"拥有自己的数字资产\"。",
  "roadmap.p2.a1": "深度融合生成式 AI 与数字人技术",
  "roadmap.p2.a2": "向品牌方输出全套的\"虚拟 IP 商业化运营策略\"",
  "roadmap.p2.a3": "打造几个百万粉级别的虚拟短视频创作者账号",
  "roadmap.p3.number": "Phase 3",
  "roadmap.p3.title": "🪐 全自动化造梦引擎",
  "roadmap.p3.target": "推出「像素怪兽」专属的工作台与项目制平台(SaaS)。",
  "roadmap.p3.a1": "沉淀我们的 AI 工作流,打造专属平台",
  "roadmap.p3.a2": "客户可通过 AI Agent 交互界面实时查看项目进度",
  "roadmap.p3.a3": "成为真正的 AI 视觉基础设施",

  // Contact
  "contact.sectionTag": "CONTACT_FORM.init",
  "contact.titleLine1": "带上你的剧本,",
  "contact.titleMain": "唤醒怪兽",
  "contact.desc1": "无论是产品广告、音乐MV、数字人IP还是展会大屏,只要你有想法,怪兽就能用 AI 算力把它变成现实。",
  "contact.highlight1": "7天交付",
  "contact.highlight2": "电影级质量，",
  "contact.highlight3": "不磨叽。",
  "contact.emailLabel": "EMAIL",
  "contact.wechatLabel": "WECHAT",
  "contact.followUs": "FOLLOW_US://",
  "contact.nameLabel": "姓名 *",
  "contact.emailFieldLabel": "邮箱 *",
  "contact.companyLabel": "公司/品牌",
  "contact.projectTypeLabel": "项目类型 *",
  "contact.namePlaceholder": "你的名字",
  "contact.emailPlaceholder": "your@email.com",
  "contact.companyPlaceholder": "你的公司名称",
  "contact.projectTypePlaceholder": "选择项目类型",
  "contact.type1": "产品广告 TVC",
  "contact.type2": "音乐 MV & 虚拟偶像",
  "contact.type3": "数字人 IP 视频",
  "contact.type4": "展会大屏 & 线下视觉",
  "contact.type5": "其他",
  "contact.messageLabel": "项目描述 *",
  "contact.messagePlaceholder": "告诉我们你的想法和需求...",
  "contact.submitBtn": "👾 启动传送",
  "contact.submitting": "正在传送中...",
  "contact.success": "发送成功!",

  // Footer
  "footer.brandName": "像素怪兽",
  "footer.tagline1": "AI  Video  Production  Studio",
  "footer.tagline2": "// 脑洞算力 · 一口吃定 · 七日交付",
  "footer.servicesTitle": "SERVICES",
  "footer.navTitle": "NAV",
  "footer.contactTitle": "CONTACT",
  "footer.s1": "产品广告 TVC",
  "footer.s2": "音乐 MV 制作",
  "footer.s3": "虚拟偶像孵化",
  "footer.s4": "数字人 IP",
  "footer.s5": "展会大屏视觉",
  "footer.s6": "AI 短剧创作",
  "footer.nav.about": "关于我们",
  "footer.nav.cases": "案例库",
  "footer.nav.roadmap": "进化蓝图",
  "footer.nav.contact": "联系我们",
  "footer.locationLabel": "Location",
  "footer.locationValue": "北京",
  "footer.deliveryLabel": "Delivery",
  "footer.deliveryValue": "7 天极速交付",
  "footer.copyright": "© 2026 PIXEL MONSTER · All Rights Reserved",
  "footer.motto": "// 别眨眼 — 怪兽正在渲染你的想象力",
  "footer.powered": "Powered by AI",

  // Shared service page nav
  "service.backHome": "返回主页",

  // Digital Human Page
  "dh.badge": "SERVICE_03 / DIGITAL_HUMAN_IP.sys",
  "dh.h1.line1": "数字人",
  "dh.h1.line2": "IP 视频",
  "dh.tagline": "// 永不疲倦的超级代言人",
  "dh.intro": "真人 KOL 会累、会涨价，但我们的数字人不会。我们提供 AI 数字人整套解决方案，让它成为您的专属赛博明星，7×24 小时为品牌持续输出内容。",
  "dh.stat1.num": "24/7",
  "dh.stat1.label": "全天候待命",
  "dh.stat2.num": "0元",
  "dh.stat2.label": "数字人工资",
  "dh.stat3.num": "10x",
  "dh.stat3.label": "内容产量提升",
  "dh.stat4.num": "∞",
  "dh.stat4.label": "形象保鲜期",
  "dh.gallery.tag": "// DIGITAL_SHOWCASE",
  "dh.gallery.title": "数字人明星案例",
  "dh.gallery.img1": "数字人代言人 · 品牌专属形象",
  "dh.gallery.img2": "短视频矩阵 · AI 数字人带货",
  "dh.gallery.img3": "直播间 · 数字人 24h 带货",
  "dh.gallery.img4": "企业吉祥物 · IP 形象孵化",
  "dh.gallery.img5": "虚拟模特 · 时尚品牌代言",
  "dh.gallery.img6": "品牌故事 · 数字人口播宣发",
  "dh.features.tag": "// CORE_CAPABILITY",
  "dh.features.title1": "真人 KOL 时代",
  "dh.features.title2": "即将被取代",
  "dh.feature1.title": "专属数字人孵化",
  "dh.feature1.desc": "完整人设+形象定制，从短视频矩阵到商业带货视频一条龙",
  "dh.feature2.title": "24/7 直播带货",
  "dh.feature2.desc": "数字人替你守着直播间，不休息、不请假、永远状态在线",
  "dh.feature3.title": "零丑闻风险",
  "dh.feature3.desc": "告别翻车危机，数字人代言永远是品牌最稳的选择",
  "dh.feature4.title": "内容工厂模式",
  "dh.feature4.desc": "同一形象批量输出差异化内容，内容产能提升 10 倍以上",
  "dh.imgTag": "// DIGITAL_HUMAN_ONLINE",
  "dh.process.tag": "// IP_BUILD_WORKFLOW",
  "dh.process.title": "四步打造你的赛博明星",
  "dh.step1.title": "IP 策划",
  "dh.step1.desc": "深挖品牌调性，设计数字人形象、人设与核心价值观",
  "dh.step2.title": "形象建模",
  "dh.step2.desc": "AI 生成超写实数字人外形，可匹配真人或全新原创形象",
  "dh.step3.title": "内容量产",
  "dh.step3.desc": "短视频脚本→拍摄渲染→后期剪辑，为品牌赋能",
  "dh.step4.title": "矩阵运营",
  "dh.step4.desc": "抖音/B站/小红书/微信等全平台同步发布，持续曝光",
  "dh.cta.tag": "// YOUR_CYBER_STAR_AWAITS",
  "dh.cta.title1": "你的专属数字人",
  "dh.cta.title2": "永不下线",
  "dh.cta.desc": "一次投入，永久输出——这才是品牌内容的终极解法",
  "dh.cta.btn": "立即召唤怪兽",

  // TVC Page
  "tvc.badge": "SERVICE_01 / PRODUCT_TVC.sys",
  "tvc.h1.line1": "产品广告",
  "tvc.h1.line2": "影视级 TVC",
  "tvc.tagline": "// 让你的产品在屏幕上\"开挂\"",
  "tvc.intro": "传统实拍拍不出水滴的完美弧线？搭不出未来的赛博朋克厨房？交给我们。用 AI 算力打破物理限制，创造令人窒息的产品视觉大片。",
  "tvc.stat1.num": "200+",
  "tvc.stat1.label": "品牌服务案例",
  "tvc.stat2.num": "48h",
  "tvc.stat2.label": "最快交付时效",
  "tvc.stat3.num": "4K/8K",
  "tvc.stat3.label": "最高输出分辨率",
  "tvc.stat4.num": "∞",
  "tvc.stat4.label": "创意无上限",
  "tvc.gallery.tag": "// CASE_GALLERY",
  "tvc.gallery.title": "怪兽级作品展示",
  "tvc.gallery.img1": "智能家居 · 未来感氛围广告",
  "tvc.gallery.img2": "男士剃须刀 · 特效大片",
  "tvc.gallery.img3": "快消饮品 · 爆炸液体创意广告",
  "tvc.gallery.img4": "新能源汽车 · 赛博光感大片",
  "tvc.gallery.img5": "奢侈手表 · 极简高级感",
  "tvc.gallery.img6": "精品餐饮 · 感官级食物美学",
  "tvc.features.tag": "// CORE_ADVANTAGE",
  "tvc.features.title1": "为什么选择",
  "tvc.features.title2": "怪兽 TVC",
  "tvc.feature1.title": "无物理限制",
  "tvc.feature1.desc": "水滴弧线、零重力悬浮、极端特写——AI 渲染让不可能成为日常",
  "tvc.feature2.title": "风格无缝切换",
  "tvc.feature2.desc": "温馨合家欢→极简高级感→赛博朋克，一个项目多套风格",
  "tvc.feature3.title": "黄金光线随叫随到",
  "tvc.feature3.desc": "不用等老天爷，怪兽的服务器里天天都是最完美的光线",
  "tvc.feature4.title": "7天极速交付",
  "tvc.feature4.desc": "从创意 Brief 到成片输出，颠覆传统实拍动辄数月的项目周期",
  "tvc.imgTag": "// PIXEL_MONSTER_STUDIO_ONLINE",
  "tvc.process.tag": "// WORKFLOW",
  "tvc.process.title": "四步完成你的 TVC 大片",
  "tvc.step1.title": "创意简报",
  "tvc.step1.desc": "品牌方提交产品信息与核心诉求，我们输出创意概念方案",
  "tvc.step2.title": "AI 分镜生成",
  "tvc.step2.desc": "基于概念，怪兽 AI 引擎实时生成高质量分镜画板",
  "tvc.step3.title": "视频渲染",
  "tvc.step3.desc": "算力全开，逐帧渲染，光影/材质/特效一步到位",
  "tvc.step4.title": "交付上线",
  "tvc.step4.desc": "多格式输出，适配抖音/B站/院线/大屏全场景",
  "tvc.cta.tag": "// READY_TO_START?",
  "tvc.cta.title1": "让你的产品",
  "tvc.cta.title2": "真正开挂",
  "tvc.cta.desc": "告诉我们你的产品故事，怪兽替你完成剩下的一切",
  "tvc.cta.btn": "立即召唤怪兽",

  // MV Page
  "mv.badge": "SERVICE_02 / MUSIC_MV_VTUBER.sys",
  "mv.h1.line1": "音乐 MV &",
  "mv.h1.line2": "虚拟偶像",
  "mv.tagline": "// 造星，我们是量产的",
  "mv.intro": "想为品牌定制超强洗脑神曲？或者推出一个永不塌房的男团女团？从 AI 词曲到 MV 画面，从偶像人设到全平台运营，怪兽一口吃定。",
  "mv.stat1.num": "50+",
  "mv.stat1.label": "虚拟偶像孵化",
  "mv.stat2.num": "多语种",
  "mv.stat2.label": "AI 演唱支持",
  "mv.stat3.num": "词曲全包",
  "mv.stat3.label": "一站式服务",
  "mv.stat4.num": "0",
  "mv.stat4.label": "塌房风险",
  "mv.gallery.tag": "// VISUAL_GALLERY",
  "mv.gallery.title": "造星作品集",
  "mv.gallery.img1": "虚拟偶像 · 全息演唱会舞台",
  "mv.gallery.img2": "AI MV · 流体粒子视觉",
  "mv.gallery.img3": "数字偶像团体 · 赛博风格造型",
  "mv.gallery.img4": "AI 音乐生成 · 声波可视化",
  "mv.gallery.img5": "虚拟偶像 · 人物设定大片",
  "mv.gallery.img6": "品牌主题曲 · 现场视觉演出",
  "mv.features.tag": "// WHY_CHOOSE_US",
  "mv.features.title1": "永不塌房的",
  "mv.features.title2": "超级造星工厂",
  "mv.feature1.title": "词曲全包·多语种演唱",
  "mv.feature1.desc": "中日韩英多语种 AI 演唱，一首歌征服全球市场",
  "mv.feature2.title": "专属人设定制",
  "mv.feature2.desc": "从外形、声线到性格，打造只属于你品牌的数字明星",
  "mv.feature3.title": "MV 画面一条龙",
  "mv.feature3.desc": "词曲生成后无缝衔接 MV 视觉制作，风格无限可能",
  "mv.feature4.title": "零塌房风险",
  "mv.feature4.desc": "数字偶像永不绯闻、永不疲倦，是最安全的品牌代言人",
  "mv.imgTag": "// IDOL_SYSTEM_ONLINE",
  "mv.process.tag": "// STAR_FACTORY_WORKFLOW",
  "mv.process.title": "四步出道你的虚拟偶像",
  "mv.step1.title": "人设定制",
  "mv.step1.desc": "品牌方确定偶像风格、声线方向和视觉形象参数",
  "mv.step2.title": "AI 词曲创作",
  "mv.step2.desc": "根据品牌调性生成多语种专属歌曲，含词、曲、演唱",
  "mv.step3.title": "MV 视觉生成",
  "mv.step3.desc": "偶像形象与 MV 画面融合渲染，帧帧电影级质感",
  "mv.step4.title": "全平台发布",
  "mv.step4.desc": "抖音/B站/YouTube/Instagram 多格式一键适配输出",
  "mv.cta.tag": "// YOUR_IDOL_IS_WAITING",
  "mv.cta.title1": "你的专属明星",
  "mv.cta.title2": "随时待命",
  "mv.cta.desc": "从一个创意出发，怪兽帮你打造整个造星宇宙",
  "mv.cta.btn": "立即召唤怪兽",

  // Exhibition Page
  "ex.badge": "SERVICE_04 / EXHIBITION_SCREEN.sys",
  "ex.h1.line1": "展会大屏 &",
  "ex.h1.line2": "线下视觉",
  "ex.tagline": "// 震撼视网膜的终极武器",
  "ex.intro": "行业展会、AI 艺术节、科技大会——让潜在客户在第一眼就被你的品牌抓住。巨幅尺寸、超高分辨率，怪兽吐出的每一帧像素都在帮你抢夺线下流量。",
  "ex.stat1.num": "8K+",
  "ex.stat1.label": "最高输出分辨率",
  "ex.stat2.num": "裸眼3D",
  "ex.stat2.label": "沉浸式视觉技术",
  "ex.stat3.num": "全场景",
  "ex.stat3.label": "线下视觉覆盖",
  "ex.stat4.num": "100%",
  "ex.stat4.label": "眼球抓住率",
  "ex.gallery.tag": "// VISUAL_IMPACT_GALLERY",
  "ex.gallery.title": "震撼级视觉作品集",
  "ex.gallery.img1": "行业展会 · LED 巨幕视觉冲击",
  "ex.gallery.img2": "裸眼 3D · 城市级视觉装置",
  "ex.gallery.img3": "科技大会 · 主舞台视觉背景",
  "ex.gallery.img4": "AI 艺术节 · 沉浸式体验空间",
  "ex.gallery.img5": "城市沙盘 · 宏大未来城市展示",
  "ex.gallery.img6": "线下大屏 · 户外超清广告牌",
  "ex.features.tag": "// SCREEN_ADVANTAGE",
  "ex.features.title1": "让你的展位",
  "ex.features.title2": "成为全场焦点",
  "ex.feature1.title": "巨幅超清输出",
  "ex.feature1.desc": "8K 及以上分辨率输出，超宽屏/异型屏/多屏拼接全支持",
  "ex.feature2.title": "裸眼 3D 先锋视觉",
  "ex.feature2.desc": "不需要眼镜的沉浸感，让你的产品从屏幕里\"走出来\"",
  "ex.feature3.title": "城市级沙盘视觉",
  "ex.feature3.desc": "宏大的未来城市规划展示，科技感爆棚的展会利器",
  "ex.feature4.title": "全场景线下覆盖",
  "ex.feature4.desc": "展会/门店/活动现场/户外大屏，一套创意多场景复用",
  "ex.imgTag": "// SCREEN_RESOLUTION_8K+",
  "ex.process.tag": "// DELIVERY_WORKFLOW",
  "ex.process.title": "四步打造你的线下视觉战场",
  "ex.step1.title": "需求诊断",
  "ex.step1.desc": "展会/场地规格确认，输出设备参数对接，视觉方案规划",
  "ex.step2.title": "创意生成",
  "ex.step2.desc": "根据品牌调性生成视觉概念，大屏分辨率专项适配设计",
  "ex.step3.title": "高分辨率渲染",
  "ex.step3.desc": "怪兽算力全开，8K/超宽屏/异型屏全规格渲染输出",
  "ex.step4.title": "现场联调交付",
  "ex.step4.desc": "支持现场设备对接调试，确保每一帧效果完美呈现",
  "ex.cta.tag": "// DOMINATE_THE_FLOOR",
  "ex.cta.title1": "下一个展会",
  "ex.cta.title2": "全场都看你",
  "ex.cta.desc": "线下流量争夺战，怪兽帮你用像素碾压所有竞争对手",
  "ex.cta.btn": "立即召唤怪兽",
};

export default zh;
